import React from 'react';

const MasjidLogos = () => {
  const logos = [
    { src: 'https://images.squarespace-cdn.com/content/v1/67743e200f50f57afe51c2af/4101bf76-d6c8-42c0-b7ed-c090c3532b10/nueces+mosque.png?format=300w/assets/nueces.png', link: 'https://www.feelingblessed.org/nueces-mosque', size: { height: '50px', marginTop: '0px', marginBottom: '0px' } }, // nueces
    { src: 'https://images.squarespace-cdn.com/content/v1/67743e200f50f57afe51c2af/f19c49a1-2116-43ea-8972-d49033b7273e/ICBC-best-logo.png?format=100w', link: 'https://icbrushycreek.org/donate/', size: { height: '55px', marginTop: '0px', marginBottom: '0px' } }, // icbc
    { src: 'https://images.squarespace-cdn.com/content/v1/67743e200f50f57afe51c2af/fec3a68c-561e-460c-8d7d-4e7a29c23069/icga_logo_512px_256px_web.jpg?format=100w', link: 'https://payments.madinaapps.com/ICGA', size: { height: '50px', marginTop: '0px', marginBottom: '0px' } }, // icga
    { src: 'https://images.squarespace-cdn.com/content/v1/67743e200f50f57afe51c2af/7d7a156d-bc28-4a79-b467-9f801178af5a/alnoormcc_logo_512.png?format=100w', link: 'https://alnoormcc.org/donate/', size: { height: '45px', marginTop: '0px', marginBottom: '0px' } }, // alnoor
    { src: 'https://images.squarespace-cdn.com/content/v1/67743e200f50f57afe51c2af/525528c9-dc91-4aa1-bd81-5e84a0c920ca/transparent-ICLT-logo-veaQE.png?format=100w', link: 'https://www.feelingblessed.org/gd/islamic-center-of-lake-travis', size: { height: '30px', marginTop: '10px', marginBottom: '10px' } }, // iclt
    { src: 'https://images.squarespace-cdn.com/content/v1/67743e200f50f57afe51c2af/84a2b730-2587-4587-b285-ad7a977dd54e/gic.png?format=1000w', link: 'https://us.mohid.co/tx/austin/gic/masjid/online/donation', size: { height: '80px', marginTop: '-12px', marginBottom: '0px' } }, // gic
    { src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSAEhwvmACa5n-wwFrkgogMulZf4ePmWhpI3A&s', size: { height: '60px', marginTop: '3px', marginBottom: '10px' } }, // icqc
    { src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT79XftaARUiGQvy3W2T1xf_mHTWv3k4RZvSA&s', link: 'https://www.donate.charitystack.com/1ecc2fec-72fc-4b88-89bd-e03e8d15465d', size: { height: '50px', marginTop: '5px', marginBottom: '0px' } }, // ichc
    { src: 'https://images.squarespace-cdn.com/content/v1/67743e200f50f57afe51c2af/9e0a3da4-3d3d-4f33-9ce5-b08888bd7814/images.png?format=100w', link: 'https://roundrockmasjid.org/donate/', size: { height: '60px', marginTop: '5px', marginBottom: '0px' } }, // icrr
    { src: 'https://www.austin-cares.org/wp-content/uploads/2015/12/austin-cares-logo.png', size: { height: '50px', marginTop: '6px', marginBottom: '0px' } }, // austin cares
  ];

  return (
    <div className="logo-links" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <div className="logo-row" style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
        {logos.slice(0, 4).map((logo, index) => (
          <div key={index} className="logo-item" style={{ margin: '0 10px' }}>
            <a href={logo.link} target="_blank" rel="noopener noreferrer">
              <img
                src={logo.src}
                alt={`Logo ${index + 1}`}
                className="logo-img"
                style={logo.size}
              />
            </a>
          </div>
        ))}
      </div>

      <div className="logo-row" style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
        {logos.slice(4).map((logo, index) => (
          <div key={index + 4} className="logo-item" style={{ margin: '0 10px' }}>
            <a href={logo.link} target="_blank" rel="noopener noreferrer">
              <img
                src={logo.src}
                alt={`Logo ${index + 5}`}
                className="logo-img"
                style={logo.size} 
              />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MasjidLogos;
